import {ButtonProps, withTheme} from '@rn-vui/themed';

import Button from '../ui-controls/Button';

export default withTheme<ButtonProps>(Button as any, 'LMGButton');

declare module '@rn-vui/themed' {
  export interface ComponentTheme {
    LMGButton: Partial<
      ButtonProps & {
        secondary?: boolean;
        variant?: 'text' | 'outlined' | 'contained';
      }
    >;
  }
}
